<template>
    <div class="">
        <div class="row no-gutter header-content">
            <div class="col-12 col-md-4 chart-title">
                Invoice Value Summary
            </div>
            <div class="col-12 col-md-6 header-right d-flex">
                <div class="navbar-nav nav dropdown dropdown-options  show inline" style="margin-left: 99px;">
                    <button type="button"
                            class="btn waves-effect waves-light ex-options-button"
                            id="dropdownMenuLink1"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true">
                        Export
                        <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                                    <i class="fa fa-chevron-down pull-right"></i>
                                </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animated fadeInUp"
                         aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item text-primary p-1 clickable" @click="exportReport('csv')">.CSV</a>
                        <a class="dropdown-item text-primary p-1 clickable" @click="exportReport('xlsx')">.XLS</a>
                    </div>
                </div>
                <div class="navbar-nav nav dropdown dropdown-options  show inline">
                    <button type="button"
                            class="btn waves-effect waves-light ex-options-button"
                            id="dropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="true">
                        {{adjustedBy}}
                        <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                                    <i class="fa fa-chevron-down pull-right"></i>
                                </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animated fadeInUp"
                         aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item text-primary p-1 clickable" @click="adjustedBy = 'Week';    selectedColumn = '';">Week</a>
                        <a class="dropdown-item text-primary p-1 clickable" @click="adjustedBy = 'Month';   selectedColumn = '';">Month</a>
                        <a class="dropdown-item text-primary p-1 clickable" @click="adjustedBy = 'Quarter'; selectedColumn = '';">Quarter</a>
                        <a class="dropdown-item text-primary p-1 clickable" @click="adjustedBy = 'Year';    selectedColumn = '';">Year</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isEmptyReportsData" class="mt-2 text-right chart-interval-block">
            <div>
                {{getDate}}
            </div>
        </div>
        <div class="chart-wrapper col-12 col-md-8">
          <vue-apex-chart
              v-if="isHasData"
              @click="onClick"
              width="1000"
              height="500"
              type="bar"
              :series="computedSeries"
              :options="computedChartOptions"
          ></vue-apex-chart>
      <div v-if="isHasData">
        <div class="navbar-nav nav dropdown dropdown-options  show inline" style="right: -827px;">
                    <button type="button"
                            class="btn waves-effect waves-light ex-options-button"
                  v-on:click="showFilters = !showFilters">
                        Filters
                        <span class="dropdown-arrow pull-right" style="box-sizing: border-box; width: 32px; border-left: 1px solid rgba(27,30,56,0.25);">
                                      <i v-if="!showFilters" class="fa fa-chevron-down pull-right"></i>
                                      <i v-if="showFilters" class="fa fa-chevron-up pull-right"></i>
                                  </span>
                    </button>

        </div>
        <div v-if="showFilters" class="active-filters-control">
          <div class="filters-checkboxes">
              <span class="filters-checkboxes-title">Display Invoice Types</span>
              <label class="form-check-inline checkbox filters-checkbox">
                <input  class="form-check-input" type="checkbox" name="excess" v-model="isTypeExcess">
                <span class="icon"><i class='bx bx-check'></i></span><span  class="text">Excess</span>
              </label>
              <label class="form-check-inline checkbox filters-checkbox">
                <input v-model="isTypeComplete"  class="form-check-input" type="checkbox" name="complete">
                <span class="icon"><i class='bx bx-check'></i></span><span class="text">Complete</span>
              </label>
          </div>
          <div v-if="!isSelectedColumn"  class="filters-checkboxes">
            <div class=""><span class="filters-checkboxes-title">Display Breakdown</span></div>

            <label class="form-check-inline checkbox filters-checkbox" @click="isDisplayBreakdownNo = false">
              <input  class="form-check-input" type="checkbox"  v-model="isDisplayBreakdownYes">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>
            </label>
            <label class="form-check-inline checkbox filters-checkbox" @click="isDisplayBreakdownYes = false">
              <input  class="form-check-input" type="checkbox" v-model="isDisplayBreakdownNo">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>
            </label>
          </div>

          <div v-if="isSelectedColumn"  class="filters-checkboxes">
            <div class=""><span class="filters-checkboxes-title">Display Payment Status</span></div>

            <label class="form-check-inline checkbox filters-checkbox" @click="isDisplayPaymentStatusNo = false">
              <input  class="form-check-input" type="checkbox"  v-model="isDisplayPaymentStatusYes">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>
            </label>
            <label class="form-check-inline checkbox filters-checkbox" @click="isDisplayPaymentStatusYes = false">
              <input  class="form-check-input" type="checkbox" v-model="isDisplayPaymentStatusNo">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>
            </label>
          </div>
          <div v-if="isSelectedColumn && isDisplayPaymentStatusYes && !isDisplayPaymentStatusNo"  class="filters-checkboxes">
            <div class=""><span class="filters-checkboxes-title">Show Payment Status</span></div>

            <label class="form-check-inline checkbox filters-checkbox">
              <input  class="form-check-input" type="checkbox"  v-model="isShowPaymentStatusAwaitingPayment">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">Awaiting Payment</span>
            </label>
            <label class="form-check-inline checkbox filters-checkbox">
              <input  class="form-check-input" type="checkbox" v-model="isShowPaymentStatusPaid">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">Paid</span>
            </label>
          </div>
          <div v-if="isSelectedColumn && isDisplayPaymentStatusYes && !isDisplayPaymentStatusNo"  class="filters-checkboxes">
            <div class=""><span class="filters-checkboxes-title">Show Payment Date</span></div>

            <label class="form-check-inline checkbox filters-checkbox" @click="isShowPaymentDateNo = false">
              <input  class="form-check-input" type="checkbox"  v-model="isShowPaymentDateYes">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">Yes</span>
            </label>
            <label class="form-check-inline checkbox filters-checkbox" @click="isShowPaymentDateYes = false">
              <input  class="form-check-input" type="checkbox" v-model="isShowPaymentDateNo">
              <span class="icon"><i class='bx bx-check'></i></span><span class="text">No</span>
            </label>
                    </div>
                </div>
            </div>

            <b-table
                    v-if="isSelectedColumn"
                    responsive
                    hover
                    :items="computedInvoiceDetailData"
                    :fields="computedFieldsForInvoiceDetail"
                    class="report-table"
            >
                <template v-slot:cell(total)="data">
                    {{data.item.total|formatMoney}}
                </template>
                <template v-slot:cell(gst)="data">
                    {{data.item.gst|formatMoney}}
                </template>
                <template v-slot:cell(subtotal)="data">
                    {{data.item.subtotal|formatMoney}}
                </template>
                <template v-slot:cell(isExcess)="data">
                    <span v-if="data.item.isExcess">Excess</span>
                    <span v-else>Complete</span>
                </template>
                <template v-slot:cell(isStatusPaid)="data">
                    <span v-if="data.item.isStatusPaid">Paid</span>
                    <span v-else>Awaiting Payment</span>
                </template>
                <template v-slot:cell(paymentDate)="data">
                    <span v-if="data.item.paymentDate">{{data.item.paymentDate}}</span>
                    <span v-else>-</span>
                </template>
            </b-table>
            <b-table
                    v-if="!isSelectedColumn && isHasData"
                    responsive
                    hover
                    :items="chartDataForTable"
                    :fields="fields"
                    class="report-table"
            >
                <template v-slot:cell(summary)="data">
                    <div>
                        <div v-if="data.item.summary === 0">
                            -
                        </div>
                        <div v-else>
                            {{data.item.summary | formatMoney}}
                        </div>
                    </div>
                </template>

                <template v-slot:cell(summaryComplete)="data">
                    <div v-if="data.item.summaryComplete === 0">
                        -
                    </div>
                    <div v-else>
                        {{data.item.summaryComplete | formatMoney}}
                    </div>
                </template>

                <template v-slot:cell(summaryExcess)="data">
                    <div v-if="data.item.summaryExcess === 0">
                        -
                    </div>
                    <div v-else>
                        {{data.item.summaryExcess | formatMoney}}
                    </div>
                </template>

            </b-table>
<!--            <p class="no-data-text" v-if="!isHasData">No data for graph</p>-->
        </div>
    </div>
</template>

<script>
    import {appConfig} from '../../../../config';
    import Multiselect from 'vue-multiselect';
    import _ from 'lodash';
    import {mapActions, mapGetters} from "vuex";
    import moment from "moment";
    import Axios from "axios";
    import VueApexCharts from 'vue-apexcharts';
    import accounting from "accounting";

    export default {
        name: "ValueSummary",
        data() {
            return {
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                invoiceDetailData: [],
                isTypeExcess: false,
                isDisplayBreakdownYes: false,
                isDisplayBreakdownNo: true,
                isDisplayPaymentStatusYes: false,
                isDisplayPaymentStatusNo: true,
                isShowPaymentStatusAwaitingPayment: true,
                isShowPaymentStatusPaid: true,
                isShowPaymentDateYes: true,
                isShowPaymentDateNo: false,
                isTypeComplete: true,
                showFilters: false,
                adjustedBy: 'Month',
                intervalUpdateReports: null,
                selectedColumn: '',
                chartEvents: {
                    'click': (event) => {
                        //  console.log('event', event);
                        if (!event.targetID.includes('bar#')) {
                            return;
                        }
                        let index = event.targetID.split('#');
                        index = index[index.length - 1];
                        if (this.selectedColumn != this.chartData[Number(index) + 1][0]) {
                            this.selectedColumn = this.chartData[Number(index) + 1][0];
                            this.clickOnChart();
                        } else {
                            this.selectedColumn = '';
                        }
                    }
                }
            };
        },
        computed: {
            ...mapGetters({
                getterIVS: 'report/getIVS',
            }),
            computedSeries() {
              let data = [{
                data: [],
              }];
              if (this.isAllInvoices) {
                data = [
                    // {
                    //   data: [],
                    //   name: 'Invoice Totals',
                    // },
                    {
                      data: [],
                      name: 'Complete',
                    },
                    {
                      data: [],
                      name: 'Excess',
                    },
                ]
              }

              if (!this.chartDataForTable) {
                return  data;
              }
              let reportData = this.adjustedBy === 'Month' || this.adjustedBy === 'Quarter' ? this.chartDataForTable.slice().reverse() : this.chartDataForTable.slice();
              _.forEach(reportData, (itm) => {
                if (this.isAllInvoices) {
                  // data[0].data.push(itm.summary)
                  data[0].data.push(itm.summaryComplete)
                  data[1].data.push(itm.summaryExcess)
                } else {
                  data[0].data.push(itm.summary)
                }
              })

              if (this.adjustedBy === 'Month') {
                if (this.isAllInvoices) {
                  data[0].data = data[0].data.slice(6, 12)
                  data[1].data = data[1].data.slice(6, 12)
                } else {
                  data[0].data = data[0].data.slice(6, 12)
                }
              }

              return data;
            },
            currentMonth() {
              return new Date().getMonth();
            },
            computedChartOptions() {
              let self = this
              let options = {
                chart: {
                  id: 'vuechart-example',
                  stacked: true,
                  toolbar: {
                    show: false,
                  },
                },
                colors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477', '#66aa00', '#b82e2e', '#316395', '#994499', '#22aa99', '#aaaa11', '#6633cc', '#e67300', '#8b0707', '#651067', '#329262', '#5574a6', '#3b3eac', '#b77322', '#16d620', '#b91383', '#f4359e', '#9c5935', '#a9c413', '#2a778d', '#668d1c', '#bea413', '#0c5922', '#743411', '#f4359e', '#b91383', '#16d620', '#b77322', '#3b3eac', '#5574a6', '#329262', '#329262', '#651067', '#8b0707', '#e67300', '#6633cc', '#aaaa11', '#22aa99', '#994499', '#316395', '#b82e2e', '#66aa00', '#dd4477', '#0099c6', '#990099', '#109618', '#ff9900', '#dc3912', '#3366cc', '#ca24d6', '#378784', '#ab8965', '#141e7d', '#edc7c7', '#167d76', '#d5f74a', '#3022c9', '#705658'],
                xaxis: {
                  categories: []
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return self.formatMoneyFunc(value)
                    }
                  },
                },
                legend: {
                  showForNullSeries: false,
                  position: 'top',
                  height: 38,
                },
                tooltip: {
                  marker: {show: true},
                  enabled: true,
                  y: {
                    title: {
                      formatter: () => {
                        return 'Invoice Totals: '
                      },
                    },
                  },
                  style: {
                    fontSize: '13px',
                    fontFamily: 'Nunito Sans',
                    fontWeight: 'bold',
                  },
                },
                dataLabels: {
                  enabled: false,
                },
              }
              let result = [];
              if (this.adjustedBy === 'Month') {
                let prevMonths = [];
                let self = this;
                _.forEach(this.months, function (item) {
                  if (self.months.indexOf(item) > self.currentMonth) {
                    prevMonths.push(item)
                  }
                })

                let currentMonths = [];
                _.forEach(self.months, function (item) {
                  let index = self.months.indexOf(item)
                  if (index <= self.currentMonth) {
                    currentMonths.push(item)
                  }
                });

                _.forEach(prevMonths, function (item) {
                  result.push(item)
                })
                _.forEach(currentMonths, function (item) {
                  result.push(item)
                });
              } else if (this.adjustedBy === 'Week') {
                result = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
              } else if (this.adjustedBy === 'Quarter') {
                let q1 = 'January - March';
                let q2 = 'April - June';
                let q3 = 'July - September';
                let q4 = 'October - December';

                let i1 = [0, 1, 2];
                let i2 = [3, 4, 5];
                let i3 = [6, 7, 8];
                let i4 = [9, 10, 11];

                if (i1.includes(this.currentMonth)) {
                  result = [
                    q2,
                    q3,
                    q4,
                    q1
                  ]
                } else if (i2.includes(this.currentMonth)) {
                  result = [
                    q3,
                    q4,
                    q1,
                    q2,
                  ]
                } else if (i3.includes(this.currentMonth)) {
                  result = [
                    q4,
                    q1,
                    q2,
                    q3,
                  ]
                } else if (i4.includes(this.currentMonth)) {
                  result = [
                    q1,
                    q2,
                    q3,
                    q4,
                  ]
                }
              } else if (this.adjustedBy === 'Year') {
                for (let key in this.getterIVS.year) {
                  result.push(key);
                }
              }

              options.xaxis.categories.splice(0, options.xaxis.categories.length);
              _.forEach(result, item => {
                options.xaxis.categories.push(item);
              })

              if (this.adjustedBy === 'Month') {
                options.xaxis.categories = options.xaxis.categories.slice(6, 12)
              }

              return options;
            },
            computedFieldsForInvoiceDetail() {
                let fields = [
                    {label: "Invoice Number", key: "invoiceNumber", sortable: true, tdClass: '',},
                    {label: "Invoice Creation Date", key: "invoiceCreationDate", sortable: true, tdClass: '',},
                    {label: "Rego", key: "rego", sortable: true, tdClass: '',},
                    {label: "Vehicle Owner", key: "vehicleOwner", sortable: true, tdClass: '',},
                    {label: "Subtotal", key: "subtotal", sortable: true, tdClass: '',},
                    {label: "GST", key: "gst", sortable: true, tdClass: '',},
                    {label: "Grandtotal", key: "total", sortable: true, tdClass: '',},
                    {label: 'Type', key: 'isExcess', sortable: true, tdClass: ''},
                ];
                if (this.isShowAwaitingPaymentStatus || this.isShowPaidStatus || this.isShowAllStatuses) {
                    fields.push({label: 'Status', key: 'isStatusPaid', sortable: true, tdClass: ''});
                }
                if (this.isShowPaymentDate) {
                    fields.push({label: 'Payment Date', key: 'paymentDate', sortable: true, tdClass: ''});
                }
                return fields;
            },
            isShowAwaitingPaymentStatus() {
                return this.isDisplayPaymentStatusYes && !this.isDisplayPaymentStatusNo && this.isShowPaymentStatusAwaitingPayment && !this.isShowPaymentStatusPaid;
            },
            isShowPaidStatus() {
                return this.isDisplayPaymentStatusYes && !this.isDisplayPaymentStatusNo && this.isShowPaymentStatusPaid && !this.isShowPaymentStatusAwaitingPayment;
            },
            isShowAllStatuses() {
                return this.isDisplayPaymentStatusYes && !this.isDisplayPaymentStatusNo && this.isShowPaymentStatusAwaitingPayment && this.isShowPaymentStatusPaid;
            },
            isShowPaymentDate() {
                return this.isDisplayPaymentStatusYes && !this.isDisplayPaymentStatusNo && this.isShowPaymentDateYes && !this.isShowPaymentDateNo;
            },
            computedInvoiceDetailData() {
                let data = this.invoiceDetailData;
                if (this.isCompleteInvoiceOnly) {
                    data = _.filter(data, (i) => {
                        return !i.isExcess;
                    });
                }
                if (this.isExcessInvoiceOnly) {
                    data = _.filter(data, (i) => {
                        return i.isExcess;
                    });
                }

                if (this.isShowAwaitingPaymentStatus) {
                    data = _.filter(data, (i) => {
                        return !i.isStatusPaid;
                    });
                }

                if (this.isShowPaidStatus) {
                    data = _.filter(data, (i) => {
                        return i.isStatusPaid;
                    });
                }

                return data;
            },
            isExcessInvoiceOnly() {
                return this.isTypeExcess && !this.isTypeComplete;
            },
            isCompleteInvoiceOnly() {
                return !this.isTypeExcess && this.isTypeComplete;
            },
            isAllInvoices() {
                return this.isTypeExcess && this.isTypeComplete && !this.isDisplayBreakdownNo && this.isDisplayBreakdownYes;
            },
            isSelectedColumn() {
                return Boolean(this.selectedColumn != '');
            },
            isHasData() {
                if (this.isEmptyReportsData) {
                    return false;
                }
                if (this.adjustedBy === 'Week') {
                    let isEmptyWeek = true;
                    for (let day in this.getterIVS.week) {
                        if (!_.isEmpty(this.getterIVS.week[day])) {
                            isEmptyWeek = false;
                            break;
                        }
                    }
                    return !this.isEmptyReportsData && !isEmptyWeek;
                } else if (this.adjustedBy === 'Year') {
                    let isEmptyYear = true;
                    for (let year in this.getterIVS.year) {
                        if (!_.isEmpty(this.getterIVS.year[year])) {
                            isEmptyYear = false;
                            break;
                        }
                    }
                    return !this.isEmptyReportsData && !isEmptyYear;
                } else if (this.adjustedBy === 'Month') {
                    let isEmptyMonth = true;
                    for (let month in this.getterIVS.month) {
                        if (!_.isEmpty(this.getterIVS.month[month])) {
                            isEmptyMonth = false;
                            break;
                        }
                    }
                    return !this.isEmptyReportsData && !isEmptyMonth;
                } else if (this.adjustedBy === 'Quarter') {
                    let isEmptyQuarter = true;
                    for (let quarter in this.getterIVS.quarter) {
                        if (!_.isEmpty(this.getterIVS.quarter[quarter])) {
                            isEmptyQuarter = false;
                            break;
                        }
                    }
                    return !this.isEmptyReportsData && !isEmptyQuarter;
                }
            },
            getDate() {
                let lastIndex = this.computedChartOptions.xaxis.categories.length - 1;
                if (this.isEmptyReportsData) {
                    return '';
                }
                if (this.adjustedBy === "Week") {
                    let monday = moment().startOf('isoweek').toDate();
                    let sunday = moment().endOf('isoweek').toDate();

                    let mDay = String(monday.getDate()).padStart(2, '0');
                    let mMonth = String(monday.getMonth() + 1).padStart(2, '0');
                    let mYear = monday.getFullYear();

                    let mResult = mDay + '/' + mMonth + '/' + mYear;

                    let sDay = String(sunday.getDate()).padStart(2, '0');
                    let sMonth = String(sunday.getMonth() + 1).padStart(2, '0');
                    let sYear = sunday.getFullYear();

                    let sResult = sDay + '/' + sMonth + '/' + sYear;

                    return 'Mon' + ' ' + mResult + ' - ' + 'Sun ' + sResult;
                } else if (this.adjustedBy === 'Month') {
                    let firstMonth = this.computedChartOptions.xaxis.categories[0];
                    let lastMonth = this.computedChartOptions.xaxis.categories[lastIndex];
                    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

                    if (lastMonth === 'December') {
                        let y1 = new Date().getFullYear();

                        return firstMonth + ' ' + y1 + ' - ' + lastMonth + ' ' + y1;
                    }

                    if (months.indexOf(firstMonth) > months.indexOf(lastMonth)) {
                        let y2 = new Date().getFullYear();
                        let y1 = y2 - 1;

                        return firstMonth + ' ' + y1 + ' - ' + lastMonth + ' ' + y2;
                    }
                } else if (this.adjustedBy === 'Quarter') {
                    let firstQuarter = this.computedChartOptions.xaxis.categories[0];
                    let lastQuarter = this.computedChartOptions.xaxis.categories[lastIndex];
                    let quarters = ['January - March', 'April - June', 'July - September', 'October - December'];

                    if (lastQuarter === 'October - December') {
                        let y1 = new Date().getFullYear();

                        return firstQuarter + ' ' + y1 + ' - ' + lastQuarter + ' ' + y1;
                    }

                    if (quarters.indexOf(firstQuarter) > quarters.indexOf(lastQuarter)) {
                        let y2 = new Date().getFullYear();
                        let y1 = y2 - 1;

                        return firstQuarter + ' ' + y1 + ' to ' + lastQuarter + ' ' + y2;
                    }
                } else if (this.adjustedBy === 'Year') {
                    let firstYear = this.computedChartOptions.xaxis.categories[0];
                    let lastYear = this.computedChartOptions.xaxis.categories[lastIndex];

                    return firstYear + ' - ' + lastYear;
                }
            },
            isEmptyReportsData() {
                return _.isEmpty(this.getterIVS);
            },
            fields() {
                let data = [];
                if (this.adjustedBy === 'Month') {
                    data.push(
                        {
                            label: "Month",
                            key: "month",
                            sortable: true,
                            tdClass: 'clickable',
                        },
                    );
                } else if (this.adjustedBy === 'Week') {
                    data.push(
                        {
                            label: "Day",
                            key: "day",
                            sortable: true,
                            tdClass: 'clickable',
                        },
                    );
                } else if (this.adjustedBy === 'Year') {
                    data.push(
                        {
                            label: "Year",
                            key: "year",
                            sortable: true,
                            tdClass: 'clickable',
                        },
                    );
                } else if (this.adjustedBy === 'Quarter') {
                    data.push(
                        {
                            label: "Quarter",
                            key: "quarter",
                            sortable: true,
                            tdClass: 'clickable',
                        },
                    );
                }

                if (this.isAllInvoices) {
                    data.push(
                        {
                            label: 'Invoice Totals',
                            key: 'summary',
                            sortable: true,
                            tdClass: 'clickable',
                        }
                    );
                    data.push(
                        {
                            label: 'Excess',
                            key: 'summaryExcess',
                            sortable: true,
                            tdClass: 'clickable',
                        }
                    );
                    data.push(
                        {
                            label: 'Complete',
                            key: 'summaryComplete',
                            sortable: true,
                            tdClass: 'clickable',
                        }
                    );
                } else {
                    data.push(
                        {
                            label: 'Invoice Totals',
                            key: 'summary',
                            sortable: true,
                            tdClass: 'clickable',
                        }
                    );
                }

                return data;
            },
            chartDataForTable() {
                if (this.isEmptyReportsData) {
                    return null;
                }
                if (this.adjustedBy === 'Month') {
                    let d = new Date();
                    let currentMonth = d.getMonth();
                    let months = [];

                    if (this.isCompleteInvoiceOnly) {
                        months = [
                            {
                                month: 'January',
                                summary: this.getterIVS.month.January.summaryComplete
                            },
                            {
                                month: 'February',
                                summary: this.getterIVS.month.February.summaryComplete
                            },
                            {
                                month: 'March',
                                summary: this.getterIVS.month.March.summaryComplete
                            },
                            {
                                month: 'April',
                                summary: this.getterIVS.month.April.summaryComplete
                            },
                            {
                                month: 'May',
                                summary: this.getterIVS.month.May.summaryComplete
                            },
                            {
                                month: 'June',
                                summary: this.getterIVS.month.June.summaryComplete
                            },
                            {
                                month: 'July',
                                summary: this.getterIVS.month.July.summaryComplete
                            },
                            {
                                month: 'August',
                                summary: this.getterIVS.month.August.summaryComplete
                            },
                            {
                                month: 'September',
                                summary: this.getterIVS.month.September.summaryComplete
                            },
                            {
                                month: 'October',
                                summary: this.getterIVS.month.October.summaryComplete
                            },
                            {
                                month: 'November',
                                summary: this.getterIVS.month.November.summaryComplete
                            },
                            {
                                month: 'December',
                                summary: this.getterIVS.month.December.summaryComplete
                            },
                        ];
                    } else if (this.isExcessInvoiceOnly) {
                        months = [
                            {
                                month: 'January',
                                summary: this.getterIVS.month.January.summaryExcess
                            },
                            {
                                month: 'February',
                                summary: this.getterIVS.month.February.summaryExcess
                            },
                            {
                                month: 'March',
                                summary: this.getterIVS.month.March.summaryExcess
                            },
                            {
                                month: 'April',
                                summary: this.getterIVS.month.April.summaryExcess
                            },
                            {
                                month: 'May',
                                summary: this.getterIVS.month.May.summaryExcess
                            },
                            {
                                month: 'June',
                                summary: this.getterIVS.month.June.summaryExcess
                            },
                            {
                                month: 'July',
                                summary: this.getterIVS.month.July.summaryExcess
                            },
                            {
                                month: 'August',
                                summary: this.getterIVS.month.August.summaryExcess
                            },
                            {
                                month: 'September',
                                summary: this.getterIVS.month.September.summaryExcess
                            },
                            {
                                month: 'October',
                                summary: this.getterIVS.month.October.summaryExcess
                            },
                            {
                                month: 'November',
                                summary: this.getterIVS.month.November.summaryExcess
                            },
                            {
                                month: 'December',
                                summary: this.getterIVS.month.December.summaryExcess
                            },
                        ];
                    } else if (this.isAllInvoices) {
                        months = [
                            {
                                month: 'January',
                                summary: this.getterIVS.month.January.summary,
                                summaryExcess: this.getterIVS.month.January.summaryExcess,
                                summaryComplete: this.getterIVS.month.January.summaryComplete,
                            },
                            {
                                month: 'February',
                                summary: this.getterIVS.month.February.summary,
                                summaryExcess: this.getterIVS.month.February.summaryExcess,
                                summaryComplete: this.getterIVS.month.February.summaryComplete,
                            },
                            {
                                month: 'March',
                                summary: this.getterIVS.month.March.summary,
                                summaryExcess: this.getterIVS.month.March.summaryExcess,
                                summaryComplete: this.getterIVS.month.March.summaryComplete,
                            },
                            {
                                month: 'April',
                                summary: this.getterIVS.month.April.summary,
                                summaryExcess: this.getterIVS.month.April.summaryExcess,
                                summaryComplete: this.getterIVS.month.April.summaryComplete,
                            },
                            {
                                month: 'May',
                                summary: this.getterIVS.month.May.summary,
                                summaryExcess: this.getterIVS.month.May.summaryExcess,
                                summaryComplete: this.getterIVS.month.May.summaryComplete,
                            },
                            {
                                month: 'June',
                                summary: this.getterIVS.month.June.summary,
                                summaryExcess: this.getterIVS.month.June.summaryExcess,
                                summaryComplete: this.getterIVS.month.June.summaryComplete,
                            },
                            {
                                month: 'July',
                                summary: this.getterIVS.month.July.summary,
                                summaryExcess: this.getterIVS.month.July.summaryExcess,
                                summaryComplete: this.getterIVS.month.July.summaryComplete,
                            },
                            {
                                month: 'August',
                                summary: this.getterIVS.month.August.summary,
                                summaryExcess: this.getterIVS.month.August.summaryExcess,
                                summaryComplete: this.getterIVS.month.August.summaryComplete,
                            },
                            {
                                month: 'September',
                                summary: this.getterIVS.month.September.summary,
                                summaryExcess: this.getterIVS.month.September.summaryExcess,
                                summaryComplete: this.getterIVS.month.September.summaryComplete,
                            },
                            {
                                month: 'October',
                                summary: this.getterIVS.month.October.summary,
                                summaryExcess: this.getterIVS.month.October.summaryExcess,
                                summaryComplete: this.getterIVS.month.October.summaryComplete,
                            },
                            {
                                month: 'November',
                                summary: this.getterIVS.month.November.summary,
                                summaryExcess: this.getterIVS.month.November.summaryExcess,
                                summaryComplete: this.getterIVS.month.November.summaryComplete,
                            },
                            {
                                month: 'December',
                                summary: this.getterIVS.month.December.summary,
                                summaryExcess: this.getterIVS.month.December.summaryExcess,
                                summaryComplete: this.getterIVS.month.December.summaryComplete,
                            },
                        ];
                    } else {
                        months = [
                            {
                                month: 'January',
                                summary: this.getterIVS.month.January.summary
                            },
                            {
                                month: 'February',
                                summary: this.getterIVS.month.February.summary
                            },
                            {
                                month: 'March',
                                summary: this.getterIVS.month.March.summary
                            },
                            {
                                month: 'April',
                                summary: this.getterIVS.month.April.summary
                            },
                            {
                                month: 'May',
                                summary: this.getterIVS.month.May.summary
                            },
                            {
                                month: 'June',
                                summary: this.getterIVS.month.June.summary
                            },
                            {
                                month: 'July',
                                summary: this.getterIVS.month.July.summary
                            },
                            {
                                month: 'August',
                                summary: this.getterIVS.month.August.summary
                            },
                            {
                                month: 'September',
                                summary: this.getterIVS.month.September.summary
                            },
                            {
                                month: 'October',
                                summary: this.getterIVS.month.October.summary
                            },
                            {
                                month: 'November',
                                summary: this.getterIVS.month.November.summary
                            },
                            {
                                month: 'December',
                                summary: this.getterIVS.month.December.summary
                            },
                        ];
                    }
                    let prevMonths = months.slice(currentMonth + 1);
                    let currentMonths = months.slice(0, currentMonth + 1);
                    return _.concat(currentMonths.reverse(), prevMonths.reverse());
                } else if (this.adjustedBy === 'Week') {
                    if (this.isCompleteInvoiceOnly) {
                        return [
                            {
                                day: 'Monday',
                                summary: this.getterIVS.week.Monday.summaryComplete,
                            },
                            {
                                day: 'Tuesday',
                                summary: this.getterIVS.week.Tuesday.summaryComplete,
                            },
                            {
                                day: 'Wednesday',
                                summary: this.getterIVS.week.Wednesday.summaryComplete,
                            },
                            {
                                day: 'Thursday',
                                summary: this.getterIVS.week.Thursday.summaryComplete,
                            },
                            {
                                day: 'Friday',
                                summary: this.getterIVS.week.Friday.summaryComplete,
                            },
                            {
                                day: 'Saturday',
                                summary: this.getterIVS.week.Saturday.summaryComplete,
                            },
                            {
                                day: 'Sunday',
                                summary: this.getterIVS.week.Sunday.summaryComplete,
                            },
                        ];
                    } else if (this.isExcessInvoiceOnly) {
                        return [
                            {
                                day: 'Monday',
                                summary: this.getterIVS.week.Monday.summaryExcess,
                            },
                            {
                                day: 'Tuesday',
                                summary: this.getterIVS.week.Tuesday.summaryExcess,
                            },
                            {
                                day: 'Wednesday',
                                summary: this.getterIVS.week.Wednesday.summaryExcess,
                            },
                            {
                                day: 'Thursday',
                                summary: this.getterIVS.week.Thursday.summaryExcess,
                            },
                            {
                                day: 'Friday',
                                summary: this.getterIVS.week.Friday.summaryExcess,
                            },
                            {
                                day: 'Saturday',
                                summary: this.getterIVS.week.Saturday.summaryExcess,
                            },
                            {
                                day: 'Sunday',
                                summary: this.getterIVS.week.Sunday.summaryExcess,
                            },
                        ];
                    } else if (this.isAllInvoices) {
                        return [
                            {
                                day: 'Monday',
                                summary: this.getterIVS.week.Monday.summary,
                                summaryExcess: this.getterIVS.week.Monday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Monday.summaryComplete,
                            },
                            {
                                day: 'Tuesday',
                                summary: this.getterIVS.week.Tuesday.summary,
                                summaryExcess: this.getterIVS.week.Tuesday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Tuesday.summaryComplete,
                            },
                            {
                                day: 'Wednesday',
                                summary: this.getterIVS.week.Wednesday.summary,
                                summaryExcess: this.getterIVS.week.Wednesday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Wednesday.summaryComplete,
                            },
                            {
                                day: 'Thursday',
                                summary: this.getterIVS.week.Thursday.summary,
                                summaryExcess: this.getterIVS.week.Thursday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Thursday.summaryComplete,
                            },
                            {
                                day: 'Friday',
                                summary: this.getterIVS.week.Friday.summary,
                                summaryExcess: this.getterIVS.week.Friday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Friday.summaryComplete,
                            },
                            {
                                day: 'Saturday',
                                summary: this.getterIVS.week.Saturday.summary,
                                summaryExcess: this.getterIVS.week.Saturday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Saturday.summaryComplete,
                            },
                            {
                                day: 'Sunday',
                                summary: this.getterIVS.week.Sunday.summary,
                                summaryExcess: this.getterIVS.week.Sunday.summaryExcess,
                                summaryComplete: this.getterIVS.week.Sunday.summaryComplete,
                            },
                        ];
                    } else {
                        return [
                            {
                                day: 'Monday',
                                summary: this.getterIVS.week.Monday.summary,
                            },
                            {
                                day: 'Tuesday',
                                summary: this.getterIVS.week.Tuesday.summary,
                            },
                            {
                                day: 'Wednesday',
                                summary: this.getterIVS.week.Wednesday.summary,
                            },
                            {
                                day: 'Thursday',
                                summary: this.getterIVS.week.Thursday.summary,
                            },
                            {
                                day: 'Friday',
                                summary: this.getterIVS.week.Friday.summary,
                            },
                            {
                                day: 'Saturday',
                                summary: this.getterIVS.week.Saturday.summary,
                            },
                            {
                                day: 'Sunday',
                                summary: this.getterIVS.week.Sunday.summary,
                            },
                        ];
                    }
                } else if (this.adjustedBy === 'Quarter') {
                    let q1 = [0, 1, 2];
                    let q2 = [3, 4, 5];
                    let q3 = [6, 7, 8];
                    let q4 = [9, 10, 11];

                    let d = new Date();
                    let currentMonth = d.getMonth();

                    let result = [];

                    if (q1.includes(currentMonth)) {
                        if (this.isCompleteInvoiceOnly) {
                            result = [
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryComplete},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryComplete},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryComplete},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryComplete},
                            ];
                        } else if (this.isExcessInvoiceOnly) {
                            result = [
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryExcess},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryExcess},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryExcess},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryExcess},
                            ];
                        } else if (this.isAllInvoices) {
                            result = [
                                {
                                    quarter: 'January - March',
                                    summaryExcess: this.getterIVS.quarter['January - March'].summaryExcess,
                                    summary: this.getterIVS.quarter['January - March'].summary,
                                    summaryComplete: this.getterIVS.quarter['January - March'].summaryComplete
                                },
                                {
                                    quarter: 'October - December',
                                    summaryExcess: this.getterIVS.quarter['October - December'].summaryExcess,
                                    summary: this.getterIVS.quarter['October - December'].summary,
                                    summaryComplete: this.getterIVS.quarter['October - December'].summaryComplete
                                },
                                {
                                    quarter: 'July - September',
                                    summaryExcess: this.getterIVS.quarter['July - September'].summaryExcess,
                                    summary: this.getterIVS.quarter['July - September'].summary,
                                    summaryComplete: this.getterIVS.quarter['July - September'].summaryComplete
                                },
                                {
                                    quarter: 'April - June',
                                    summaryExcess: this.getterIVS.quarter['April - June'].summaryExcess,
                                    summary: this.getterIVS.quarter['April - June'].summary,
                                    summaryComplete: this.getterIVS.quarter['April - June'].summaryComplete
                                },
                            ];
                        } else {
                            result = [
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summary},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summary},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summary},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summary},
                            ];
                        }
                    } else if (q2.includes(currentMonth)) {
                        if (this.isCompleteInvoiceOnly) {
                            result = [
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryComplete},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryComplete},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryComplete},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryComplete},
                            ];
                        } else if (this.isExcessInvoiceOnly) {
                            result = [
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryExcess},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryExcess},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryExcess},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryExcess},
                            ];
                        } else if (this.isAllInvoices) {
                            result = [
                                {
                                    quarter: 'April - June',
                                    summaryExcess: this.getterIVS.quarter['April - June'].summaryExcess,
                                    summary: this.getterIVS.quarter['April - June'].summary,
                                    summaryComplete: this.getterIVS.quarter['April - June'].summaryComplete
                                },
                                {
                                    quarter: 'January - March',
                                    summaryExcess: this.getterIVS.quarter['January - March'].summaryExcess,
                                    summary: this.getterIVS.quarter['January - March'].summary,
                                    summaryComplete: this.getterIVS.quarter['January - March'].summaryComplete
                                },
                                {
                                    quarter: 'October - December',
                                    summaryExcess: this.getterIVS.quarter['October - December'].summaryExcess,
                                    summary: this.getterIVS.quarter['October - December'].summary,
                                    summaryComplete: this.getterIVS.quarter['October - December'].summaryComplete
                                },
                                {
                                    quarter: 'July - September',
                                    summaryExcess: this.getterIVS.quarter['July - September'].summaryExcess,
                                    summary: this.getterIVS.quarter['July - September'].summary,
                                    summaryComplete: this.getterIVS.quarter['July - September'].summaryComplete
                                },
                            ];
                        } else {
                            result = [
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summary},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summary},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summary},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summary},
                            ];
                        }
                    } else if (q3.includes(currentMonth)) {
                        if (this.isCompleteInvoiceOnly) {
                            result = [
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryComplete},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryComplete},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryComplete},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryComplete},
                            ];
                        } else if (this.isExcessInvoiceOnly) {
                            result = [
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryExcess},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryExcess},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryExcess},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryExcess},
                            ];
                        } else if (this.isAllInvoices) {
                            result = [
                                {
                                    quarter: 'July - September',
                                    summaryExcess: this.getterIVS.quarter['July - September'].summaryExcess,
                                    summary: this.getterIVS.quarter['July - September'].summary,
                                    summaryComplete: this.getterIVS.quarter['July - September'].summaryComplete
                                },
                                {
                                    quarter: 'April - June',
                                    summaryExcess: this.getterIVS.quarter['April - June'].summaryExcess,
                                    summary: this.getterIVS.quarter['April - June'].summary,
                                    summaryComplete: this.getterIVS.quarter['April - June'].summaryComplete
                                },
                                {
                                    quarter: 'January - March',
                                    summaryExcess: this.getterIVS.quarter['January - March'].summaryExcess,
                                    summary: this.getterIVS.quarter['January - March'].summary,
                                    summaryComplete: this.getterIVS.quarter['January - March'].summaryComplete
                                },
                                {
                                    quarter: 'October - December',
                                    summaryExcess: this.getterIVS.quarter['October - December'].summaryExcess,
                                    summary: this.getterIVS.quarter['October - December'].summary,
                                    summaryComplete: this.getterIVS.quarter['October - December'].summaryComplete
                                },
                            ];
                        } else {
                            result = [
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summary},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summary},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summary},
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summary},
                            ];
                        }
                    } else if (q4.includes(currentMonth)) {
                        if (this.isCompleteInvoiceOnly) {
                            result = [
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryComplete},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryComplete},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryComplete},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryComplete},
                            ];
                        } else if (this.isExcessInvoiceOnly) {
                            result = [
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summaryExcess},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summaryExcess},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summaryExcess},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summaryExcess},
                            ];
                        } else if (this.isAllInvoices) {
                            result = [
                                {
                                    quarter: 'October - December',
                                    summaryExcess: this.getterIVS.quarter['October - December'].summaryExcess,
                                    summary: this.getterIVS.quarter['October - December'].summary,
                                    summaryComplete: this.getterIVS.quarter['October - December'].summaryComplete
                                },
                                {
                                    quarter: 'July - September',
                                    summaryExcess: this.getterIVS.quarter['July - September'].summaryExcess,
                                    summary: this.getterIVS.quarter['July - September'].summary,
                                    summaryComplete: this.getterIVS.quarter['July - September'].summaryComplete
                                },
                                {
                                    quarter: 'April - June',
                                    summaryExcess: this.getterIVS.quarter['April - June'].summaryExcess,
                                    summary: this.getterIVS.quarter['April - June'].summary,
                                    summaryComplete: this.getterIVS.quarter['April - June'].summaryComplete
                                },
                                {
                                    quarter: 'January - March',
                                    summaryExcess: this.getterIVS.quarter['January - March'].summaryExcess,
                                    summary: this.getterIVS.quarter['January - March'].summary,
                                    summaryComplete: this.getterIVS.quarter['January - March'].summaryComplete
                                },
                            ];
                        } else {
                            result = [
                                {quarter: 'October - December', summary: this.getterIVS.quarter['October - December'].summary},
                                {quarter: 'July - September', summary: this.getterIVS.quarter['July - September'].summary},
                                {quarter: 'April - June', summary: this.getterIVS.quarter['April - June'].summary},
                                {quarter: 'January - March', summary: this.getterIVS.quarter['January - March'].summary},
                            ];
                        }
                    }

                    return result;
                } else if (this.adjustedBy === 'Year') {
                    let data = [];

                    if (this.isCompleteInvoiceOnly) {
                        for (let year in this.getterIVS.year) {
                            data.push(
                                {
                                    year: year,
                                    summary: this.getterIVS.year[year].summaryComplete,
                                });
                        }
                    } else if (this.isExcessInvoiceOnly) {
                        for (let year in this.getterIVS.year) {
                            data.push(
                                {
                                    year: year,
                                    summary: this.getterIVS.year[year].summaryExcess,
                                });
                        }
                    } else if (this.isAllInvoices) {
                        for (let year in this.getterIVS.year) {
                            data.push(
                                {
                                    year: year,
                                    summary: this.getterIVS.year[year].summary,
                                    summaryExcess: this.getterIVS.year[year].summaryExcess,
                                    summaryComplete: this.getterIVS.year[year].summaryComplete,
                                });
                        }
                    } else {
                        for (let year in this.getterIVS.year) {
                            data.push(
                                {
                                    year: year,
                                    summary: this.getterIVS.year[year].summary,
                                });
                        }
                    }

                    return data;
                }

            },
        },
        methods: {
            ...mapActions({
                actionLoadReports: 'report/loadIPSAndIVSAndAIV',
            }),
          formatMoneyFunc(value) {
            return accounting.formatMoney(value)
          },
            onClick(event, context, config){
              if (this.selectedColumn === this.computedChartOptions.xaxis.categories[config.dataPointIndex] || config.dataPointIndex === -1) {
                this.selectedColumn = '';
                return;
              }
              this.selectedColumn = this.computedChartOptions.xaxis.categories[config.dataPointIndex];
              if (this.adjustedBy == 'week') {
                return;
              }
              NProgress.start();
              Axios.get('/fe/reports/invoice/details/' + _.toLower(this.adjustedBy) + '/' + _.toLower(this.selectedColumn.replace(/\s+/g, '')))
                  .then(response => {
                    this.invoiceDetailData = response.data.data;
                  })
                  .catch(error => {
                    console.log(error);

                  }).finally(() => {
                NProgress.done();
              });
            },
            getCurrentFilters() {
                let filters = '';
                if (this.isTypeExcess === false || this.isTypeComplete === false) {
                    if (this.isTypeExcess === true) {
                        filters += 'isTypeExcess;';
                    }
                    if (this.isTypeComplete === true) {
                        filters += 'isTypeComplete;';
                    }
                }
                if (this.isDisplayBreakdownYes === true) {
                    filters += 'isDisplayBreakdownYes;';
                }
                if (filters == '') {
                    return false;
                }
                return filters;
            },
            getCurrentFiltersForDetails() {
                let filters = '';
                if (this.isTypeExcess === false || this.isTypeComplete === false) {
                    if (this.isTypeExcess === true) {
                        filters += 'isTypeExcess;';
                    }
                    if (this.isTypeComplete === true) {
                        filters += 'isTypeComplete;';
                    }
                }
                if (this.isDisplayBreakdownYes === true) {
                    filters += 'isDisplayBreakdownYes;';
                }
                if (this.isDisplayPaymentStatusYes === true) {
                    filters += 'isDisplayPaymentStatusYes;';
                }
                if (this.isShowPaymentStatusAwaitingPayment === true) {
                    filters += 'isShowPaymentStatusAwaitingPayment;';
                }
                if (this.isShowPaymentStatusPaid === true) {
                    filters += 'isShowPaymentStatusPaid;';
                }
                if (this.isShowPaymentDateYes === true) {
                    filters += 'isShowPaymentDateYes;';
                }
                if (filters == '') {
                    return false;
                }
                return filters;
            },
            exportReport(format) {
                let token = localStorage.getItem('token');
                if (this.isSelectedColumn) {
                    let filters = this.getCurrentFiltersForDetails();
                    let url = appConfig.baseAPIURL;
                    url += '/fe/reports/download/invoices/details/';
                    url += _.toLower(this.adjustedBy);
                    url += '/';
                    url += _.toLower(this.selectedColumn.replace(/\\s+/g, ''));
                    url += '/';
                    url += format;
                    url += '?at=' + token;
                    if (filters) {
                        url += '&filters=' + filters;
                    }
                  //empty line
                  (async (url) => {
                    const popup = window.open('', '_blank')
                    if (popup) {
                      popup.location.href = url
                    }
                  })(url)
                } else {
                    let filters = this.getCurrentFilters();
                    let type = 'ps';
                    let period = _.toLower(this.adjustedBy);
                    let value = 'summary';

                    if (this.isTypeExcess && !this.isTypeComplete) {
                      value = 'summaryExcess'
                    } else if (!this.isTypeExcess && this.isTypeComplete) {
                      value = 'summaryComplete'
                    }

                    let url = appConfig.baseAPIURL + `/fe/reports/download/invoices/${type}/${period}/${value}/${format}?at=${token}`;
                    if (value === 'summary' && this.isDisplayBreakdownYes === true) {
                      url+= '&displayBreakdown=yes';
                    }
                  //empty line
                  (async (url) => {
                    const popup = window.open('', '_blank')
                    if (popup) {
                      popup.location.href = url
                    }
                  })(url)
                }
                return;
            }
        },
        mounted() {
            NProgress.start();
            this.actionLoadReports();
            let self = this;
            this.intervalUpdateReports = setInterval(() => {
                if (!_.isEmpty(self.getterIVS) && !_.isEmpty(self.computedSeries) && !_.isEmpty(self.computedChartOptions) && !_.isEmpty(self.chartDataForTable)) {
                    NProgress.done();
                }
            }, 1000);
        },
        beforeDestroy() {
            clearInterval(this.intervalUpdateReports);
        },
        components: {
            Multiselect,
            "vue-apex-chart": VueApexCharts,
        },
    };
</script>

<style scoped>
  .active-filters-control {
    display: flex;
    flex-direction: column;
    width: 880px;
    position: relative;
    left: 96px;
    border: 1px solid rgba(27, 30, 56, 0.25);
  }

  .filters-checkboxes {
    padding: 10px 0 15px 15px;
    display: flex;
  }

  .filters-checkboxes-title {
    display: inline-block !important;
    width: 200px;
  }

  .filters-checkbox {
    display: flex;
    margin-right: 30px;
    display: inline-block !important;
    width: 100px;
  }
</style>
